module.exports = __webpack_public_path__ + "img/tab-bg1.d654b71c.png";